module.exports = __webpack_public_path__ + "assets/img/00123.42edb0ea.png";